import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment2FuelTypeInfo } from "../state";


interface Assessment2DownloadCSVProps {
    fuelTypes: Assessment2FuelTypeInfo[];
}

function Assessment2DownloadCSV({ fuelTypes }: Assessment2DownloadCSVProps) {

    
    const csvData = [["Fuel", "Issue", "Action Plan"]];
        let rowIndex:number = 1;
        //iterate fuel types
        fuelTypes.map(fuel => {
            if(fuel.clientWaiversMeetVendorRequirements === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors requirements for data security and privacy"
                                      , fuel.clientWaiversMeetVendorRequirementsDesc];
                rowIndex++; 
            }
            if(fuel.vendorAgreementsHaveDataCollectionRequirements === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors agreements have data collection requirements"
                                      , fuel.vendorAgreementsHaveDataCollectionRequirementsDesc];
                rowIndex++; 
            }
            if(fuel.vendorsAlertedTimelyManner === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors alerted in a timely manner"
                                      , fuel.vendorsAlertedTimelyMannerDesc];
                rowIndex++; 
            }
            if(fuel.showSetUpMeeting == true)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Please set up a meeting with vendors to figure out what can be done to ensure that you receive all the necessary data."
                                      , fuel.setUpMeetingDesc];
                rowIndex++; 
            }
        });
    return (
      <CSVLink data={csvData}  filename="MainHeatingFuelAssessment2.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment2DownloadCSV;
